import * as React from 'react';
import classNames from "classnames";
import styles from './Icon.scss';

export type IconType = { viewBox: string, id: string, url: string };

export type Props = {
  icon: IconType,
  className?: string,
  [prop: string]: any
};

const loadedUrls: Record<string, boolean> = {}
const loadSprite = (icon: IconType) => {
  const [spriteUrl, id] = icon.url.split('#');
  if (!loadedUrls[spriteUrl]) {
    loadedUrls[spriteUrl] = true;
    fetch(spriteUrl).then((resp) => resp.text()).then(response => {
      const currentSprite = document.getElementById('__SVG_SPRITES__');
      if (currentSprite) currentSprite.remove();
      document.body.insertAdjacentHTML('beforeend', response);
    });
  }
  return id;
}

export default function Icon({ icon, className, ...props }: Props) {
  const id = loadSprite(icon);
  return (
    <svg viewBox={icon.viewBox} className={classNames(styles.icon, className)} {...props}>
      <use xlinkHref={'#' + id} />
    </svg>
  );
};
